// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"214":"4886a760","236":"17c78dc2","410":"c537abbe","864":"505b0a8d","932":"6b7d4656"}[chunkId] + ".css";
};